// eslint-disable-next-line no-shadow
export enum RecaptchaAction {
  B2C_UPDATE_PERSONAL_DETAILS = 'B2C_Update_Personal_Details',
}
